import ContentActions from './ContentActions';

export default ContentActions;
